import { type ReactNode } from "react";
import styled from "@emotion/styled";

export type LayoutShellProps = {
  header?: ReactNode;
  sidebar?: ReactNode;
  children: ReactNode;
  className?: string;
};

/* Exact compiled output of the pre-migration Tailwind utilities. The
 * backdrop-blur chain is inlined to its computed equivalent. */

const LayoutShellRoot = styled("div", {
  label: "AgenticLayoutShell-root"
})({
  minHeight: "100dvh",
  "--tw-bg-opacity": "1",
  backgroundColor: "hsl(var(--bfrs-color-surface-app) / var(--tw-bg-opacity, 1))",
  "--tw-text-opacity": "1",
  color: "hsl(var(--bfrs-color-text-primary) / var(--tw-text-opacity, 1))"
});

const LayoutShellHeader = styled("header", {
  label: "AgenticLayoutShell-header"
})({
  position: "sticky",
  top: 0,
  zIndex: 30,
  borderBottomWidth: "1px",
  "--tw-border-opacity": "1",
  borderColor: "hsl(var(--bfrs-color-border) / var(--tw-border-opacity, 1))",
  backgroundColor: "hsl(var(--bfrs-color-surface-card) / .9)",
  WebkitBackdropFilter: "blur(8px)",
  backdropFilter: "blur(8px)"
});

const LayoutShellBody = styled("div", {
  label: "AgenticLayoutShell-body"
})({
  marginLeft: "auto",
  marginRight: "auto",
  display: "grid",
  width: "100%",
  maxWidth: "80rem",
  gap: "1.5rem",
  paddingLeft: "1.25rem",
  paddingRight: "1.25rem",
  paddingTop: "1.5rem",
  paddingBottom: "1.5rem",
  "@media (min-width:640px)": {
    paddingLeft: "2rem",
    paddingRight: "2rem"
  },
  "@media (min-width:1024px)": {
    gridTemplateColumns: "260px minmax(0,1fr)"
  }
});

const LayoutShellSidebar = styled("aside", {
  label: "AgenticLayoutShell-sidebar"
})({
  display: "none",
  "@media (min-width:1024px)": {
    display: "block"
  }
});

const LayoutShellMain = styled("main", {
  label: "AgenticLayoutShell-main"
})({
  minWidth: "0px"
});

export function LayoutShell({ header, sidebar, children, className }: LayoutShellProps) {
  return (
    <LayoutShellRoot className={className}>
      {header && <LayoutShellHeader>{header}</LayoutShellHeader>}
      <LayoutShellBody>
        {sidebar && <LayoutShellSidebar>{sidebar}</LayoutShellSidebar>}
        <LayoutShellMain>{children}</LayoutShellMain>
      </LayoutShellBody>
    </LayoutShellRoot>
  );
}
